"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
// text field

const styleOverrides = {
  root: ({
    theme
  }) => ({
    borderRadius: theme.shape.borderRadius,
    [`&.${_material.outlinedInputClasses.multiline} .${_material.inputAdornmentClasses.root}`]: {
      alignSelf: 'flex-start',
      marginTop: 16,
      marginRight: 4,
      marginLeft: 4
    }
  }),
  inputSizeSmall: {
    padding: '8.5px 14px'
  },
  adornedStart: {
    [`& .${_material.outlinedInputClasses.input}`]: {
      paddingLeft: 0
    }
  },
  adornedEnd: {
    [`& .${_material.outlinedInputClasses.input}`]: {
      paddingRight: 0
    }
  },
  notchedOutline: ({
    theme
  }) => ({
    background: 'unset',
    borderColor: theme.palette.grey[500],
    '& legend': {
      position: 'unset'
    }
  }),
  multiline: {
    padding: 15
  }
};
const defaultProps = {
  color: 'inputElements'
};
var _default = exports.default = {
  styleOverrides,
  defaultProps
};
//# sourceMappingURL=MuiOutlinedInput.js.map